module.exports = __webpack_public_path__ + "img/红心初级大师@3x.2dc2423a.png";